//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            isDisabled: false
        };
    },

    methods: {
        rebuild: function rebuild() {
            var _this = this;

            this.isDisabled = true;
            axios.post('/prototype/accounting/general-ledger/settings/rebuild-gl-cache').then(function () {
                _this.$snotify.info('GL cache successfully rebuilt');
                _this.isDisabled = false;
            }).catch(function () {
                _this.$snotify('An unknown error occurred.');
                _this.isDisabled = false;
            });
        }
    },
    computed: {
        isAdmin: function isAdmin() {
            return window.user.role === 'super-admin' || window.user.role === 'accounting-admin';
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/settings/RebuildGLCache.vue
// module id = ZGty
// module chunks = 0 1